import styled from '@emotion/styled'
import { TheWestByline } from '../../../../publication/Byline/TheWestByline'
import { breakpoint, calcRem, fonts, metrics } from '../../../../__styling'

export const StyledArticleHeaderContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',

    gap: calcRem(18),
    paddingBottom: calcRem(24),
})

export const StyledDivider = styled('div')({
    height: calcRem(1),
    background: '#E5E5E5',
})

export const StyledTheWestArticleByline = styled(TheWestByline)({
    [breakpoint('xs')]: {
        paddingBottom: calcRem(metrics.thewest.margins.sm),
    },
})
